export default __webpack_public_path__ + "static/media/cynoia.7bde6647.avif";